import { render, staticRenderFns } from "./LensTechDescription.vue?vue&type=template&id=48f224cd&"
import script from "./LensTechDescription.vue?vue&type=script&lang=js&"
export * from "./LensTechDescription.vue?vue&type=script&lang=js&"
import style0 from "./LensTechDescription.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default})
